import { r as o } from "./base-CwU3eNq--CZuQwsDV.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let e;
function c(t) {
  return (l, n) => o(l, n, { get() {
    var r;
    return ((r = this.renderRoot) != null ? r : e != null ? e : e = document.createDocumentFragment()).querySelectorAll(t);
  } });
}
export {
  c as queryAll
};
